module.exports = __webpack_public_path__ + "static/img/good-fresh-bg-outer.4962953.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/good-fresh/good-fresh-bg-outer.jpg
// module id = G6JB
// module chunks = 1